module.exports = __webpack_public_path__ + "media/fonts/themify-eda8b94308c6f538f04a8056ed761a57.ttf";